import { render } from "./MakePledge.vue?vue&type=template&id=57f5d621&scoped=true"
import script from "./MakePledge.vue?vue&type=script&lang=js"
export * from "./MakePledge.vue?vue&type=script&lang=js"

import "./MakePledge.vue?vue&type=style&index=0&id=57f5d621&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f5d621"]])

export default __exports__